import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useAuth } from '../context/AuthContext';
import { GET_ME } from '../graphql/queries';
import './UserStatus.css';

const REST_BASE = process.env.REACT_APP_REST_ENDPOINT_BASE || '';

const UserStatus = () => {
  const { token, logout } = useAuth();
  const { data } = useQuery(GET_ME, { skip: !token });

  const user = data?.me;

  if (token && user) {
    return (
      <div className="user-status">
        <Link to="/mypage" className="user-status__name">{user.screenName}</Link>
        <button className="user-status__logout" onClick={logout}>
          ログアウト
        </button>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="user-status">
        <a className="user-status__login" href={`${REST_BASE}/auth/google_oauth2`}>
          Googleでログイン
        </a>
      </div>
    );
  }

  return null;
};

export default UserStatus;
